<template>
    <div class="inf-select-con f-inlineblock-top">
        <input class="inf-select-input g-input f-inlineblock-top" type="text" v-model="curItem.text" @focus="show = true" @blur="handleBlur" @change="search" :placeholder="placeholder">
        <span class="ico ico-down js-inf-select-icon" @click="show = !show"></span>
        <!--
            下拉菜单
        -->
        <div class="g-selector-option" v-show="show">
            <div class="selector g-scrollbar">
                <div class="select-item" @click="chooceItem(item)" v-for="(item,index) in list" :key="index">{{item.text}}</div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/information/information.scss';
</style>
<script>
export default {
    props: ['list', 'placeholder'],
    data(){
        return {
            show: false,
            curItem: {
                text: '',
                id: ''
            },
            listBackup: []
        }
    },
    mounted(){
        this.$nextTick(()=>{
            let timer = setInterval(()=>{
                if(this.list && this.list!=undefined && this.list.length){
                    this.listBackup = this.list.slice();
                    clearInterval(timer);
                }
            }, 100)
        })
    },
    methods: {
        search (){
            let reg = this.curItem.text;
            let result = [];
            this.listBackup.forEach( v => {
                // debugger
                if(v.text.indexOf(reg) != -1){
                    console.log(v)
                    result.push(v)
                }
            })
            this.list = result;
            if(!this.curItem.text){
                this.curItem = {};
                this.$emit('change', this.curItem);
            }
        },
        chooceItem(item){
            this.show = false;
            this.curItem = Object.assign({}, item);
            this.$emit('change', item);
        },
        handleBlur(){
            setTimeout(()=>{
                this.show = false;
            }, 180)
        }
    }
}
</script>
